import { Text } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import { FC } from 'react';
import { colors } from 'src/utils/colors';

interface IErrorLabel {
	name: string;
}

export const ErrorLabel: FC<IErrorLabel> = ({ name }) => {
	const { errors, touched } = useFormikContext();

	return (
		<Text
			mt="5px"
			fontSize="12px"
			color={colors.primary}
		>
			{errors && get(errors, name) && get(touched, name) ? <div>{get(errors, name)}</div> : null}
		</Text>
	);
};
